import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"

export default function GardenPlan({ data }) {
  const html = data.markdownRemark.html

  return (
    <Layout>
      <h1>Garden Plan</h1>
      <div dangerouslySetInnerHTML={{ __html: html }} className="garden-plan" />
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    markdownRemark(
      frontmatter: { type: { eq: "page" }, page: { eq: "garden-plan" } }
    ) {
      html
    }
  }
`
